<template>
  <div class="common-body"> 
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <a class="article-banner" :href="commonBannerAddress" target="_blank">
      <img class="article-img" :src="baseAddress+commonBanner">
    </a>
    <div class="article-body">
      <h1 class="article-title">{{commonTitle}}</h1>
      <div class="article-content" v-html="unescapeHTML(commonContent)"></div> 
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
      @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
      @changeLoginState="changeLoginState"></SuspendMember>
  </div>
</template>
<script>
  import Footer from "../../components/common/Footer";
  import Header from "../../components/common/Header";
  import SuspendSide from "../../components/SuspendSide";
  import SuspendMember from '../../components/SuspendMember';
  export default {
    metaInfo(){
      return {
        title:"关于我们_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    components:{ Footer, Header, SuspendSide, SuspendMember},
    computed:{
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      },
    },
    asyncData({store,route}){
      return store.dispatch('initSeo',{store:store});
    },
    data(){
      return{
        suspendState:false,
        suspendType:0,
        loginState:false,
        commonBanner:"",
        commonTitle:"",
        commonContent:"",
        commonBannerAddress:""
      }
    },
    mounted(){
      this.queryCommonInfo();
    }, 
    methods:{ 
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      queryCommonInfo(){
        this.$http.get('/query_common_info?type=7', {}).then(res=>{
          if(res.data.code == 2000){
            this.commonBanner = res.data.data.about_we_banner;
            this.commonContent = res.data.data.about_we_content;
            this.commonTitle = res.data.data.about_we_title;
            this.commonBannerAddress = res.data.data.about_we_banner_address;
          }
        });
      },
      unescapeHTML: function(content){
        content = "" + content;
        content = content.replace(/&lt;/g, "<").replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&").replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'")
        .replace(new RegExp('background-color: #ffffff;','g'), "")
        .replace(new RegExp('background:rgb(255,255,255)','g'), "")
        .replace(new RegExp('background: rgb(255, 255, 255)','g'), "")
        .replace(new RegExp('background: #ffffff;','g'),"");
        content = content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
          let replace;
          if(capture.substr(0,7) == 'http://'){
            replace = capture;
          }else if(capture.substr(0,1) =="/"){
            replace = this.baseAddress+capture;
          }else{
            replace = this.baseAddress+"/"+capture;
          }
          return match.replace(capture,replace);
        });
        return content;
      },
    },
  }
</script>
<style>
  .article-content{
    width: 980px;
    min-height: 680px;
    margin: 0 auto;
    padding: 20px;
  }

  .article-content{
    font-size: 16px;
  }

  .article-content img{
    width: 100%;
    height: 100%;
  }

  .article-content table{
    width: 100%;
  }

  .article-banner{
    width: 100%;
    height: 490px;
    position: relative;
    display: block;
    background: url("../../assets/image/banner_bg.jpg") no-repeat;
    background-size: 100% auto;
  }

  .article-title{
    font-size: 28px;
    color: #ff7e00;
    font-weight: normal;
    text-align: center;
  }
  
  .article-img{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    max-width: 1920px;
    left: 50%;
    transform: translateX(-50%);
  }

  .article-content p,.article-content span{
    color: rgba(21, 21, 21, 0.73);
  }

  .article-body{
    width: 980px;
    margin: 0 auto 34px auto;
    padding-top: 40px;
  }
  </style>